import _ from '../../core/utils'

const SCROLLTO_CONFIG = {
    scrolltos: _.selectAll( '.c-scrollto' ),
    offset: 0,
    duration: 1
}

export default SCROLLTO_CONFIG